import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-138" data-mp="1wal1wialzfoj" />, document.getElementById("root"));